import React from 'react';
import moment from 'moment';

const NotesTable = ({ notes, currentUserId, onEdit, onDelete }) => {
    return (
        <div className='table_responsive'>
            <table className="table">
                <thead className="text-primary">
                    <tr>
                        <th className="col-1">#</th>
                        <th className="col-2">User</th>
                        <th className="col-4">Notes</th>
                        <th className="col-3">Added at</th>
                        <th className="col-2 text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {notes && notes.length > 0 ? (
                        notes.map((note, index) => (
                            <tr key={note.id}>
                                <td>{index + 1}</td>
                                <td>{note.user?.name}</td>
                                <td>{note.note}</td>
                                <td>{moment(note.created_at).format('MMMM DD YYYY, hh:mm A')}</td>
                                <td className="text-center">
                                    {note.user_id === currentUserId && (
                                        <div className="d-flex justify-content-center gap-2">
                                            <button 
                                                className="table_edit" 
                                                onClick={() => onEdit(note)}
                                                title="Edit Note"
                                            >
                                                <i className="fa fa-edit"></i>
                                            </button>
                                            <button 
                                                className="table_delete" 
                                                onClick={() => onDelete(note.id)}
                                                title="Delete Note"
                                            >
                                                <i className="fa fa-trash"></i>
                                            </button>
                                        </div>
                                    )}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="5" className="text-center">No notes found.</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default NotesTable;
